import { AxiosResponse } from 'axios';

import API from './api';

import { IAPI } from './IAPI';
import { Vehicle } from '../Models/Vehicle.model';
import { notification } from 'antd';

const VehicleAPI = (baseUrl: IAPI) => {
    const api = API(baseUrl);

    const getVehicles = (SysInstitutionId: number): Promise<Vehicle[]> => {
        const serviceUrl = '/api/v1/BookBuildingVehicle';
        return api.get(serviceUrl, { params: { SysInstitutionId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error) => notification.error({
				message: 'Error',
				description: `Failed to fetch vehicles: ${error.message}`,
			}));
    };

    return {
        getVehicles
    };
};

export default VehicleAPI;